<script>
  import { user } from "../stores";

  import ClassColor from "../components/ClassColor.svelte";
  import { getTeacherClass } from "../database/classes";

  let thisDoc, thisClass;
  const colors = ["grey", "blue", "green", "orange", "red"];
  let isCounting = false;
  let count = "";
  let currentColor, previousColor;
  let firstLoad = true;

  getTeacherClass($user.uid).then((val) => {
    thisDoc = val;
    thisDoc.ref.onSnapshot((snap) => {
      thisDoc = snap;
      thisClass = thisDoc.data();
      if (thisClass.previous) {
        previousColor = thisClass.previous;
      } else {
        previousColor = thisClass.currentColor;
      }
      currentColor = thisClass.currentColor;
      colorCycle();

      if (firstLoad) {
        previousColor = "";
        firstLoad = false;
      }
    });
  });

  const changeColor = (color) => {
    let previous = "";
    if (thisClass.currentColor) previous = thisClass.currentColor;
    thisDoc.ref.update({ currentColor: color, previous });
  };

  const colorCycle = () => {
    isCounting = true;
    count = "3";
    setTimeout(() => {
      count = "2";
    }, 1000);
    setTimeout(() => {
      count = "1";
    }, 2000);
    setTimeout(() => {
      previousColor = currentColor;
      isCounting = false;
    }, 3000);
  };
</script>

{#if thisClass}
  <h1 class="title is-4">Your Class ({thisDoc.id})</h1>
  <div
    class="is-flex is-mobile is-align-items-center is-justify-content-center"
  >
    <div class="mr-1" style="width: 176px;">
      <ClassColor color={previousColor} />
    </div>
    <div class="" style="width: 176px;">
      <ClassColor color={currentColor} {isCounting} {count} />
    </div>
  </div>
  <hr />
  <div class="columns is-mobile">
    <div class="column">
      <button
        class="button is-large is-fullwidth has-background-grey"
        on:click={() => changeColor("grey")}
      />
    </div>
    <div class="column">
      <button
        class="button is-large is-fullwidth has-background-blue"
        on:click={() => changeColor("blue")}
      />
    </div>
  </div>
  <div class="columns is-mobile">
    <div class="column">
      <button
        class="button is-large is-fullwidth has-background-green"
        on:click={() => changeColor("green")}
      />
    </div>
    <div class="column">
      <button
        class="button is-large is-fullwidth has-background-orange"
        on:click={() => changeColor("orange")}
      />
    </div>
  </div>
  <div class="columns is-mobile">
    <div class="column">
      <button
        class="button is-large is-fullwidth has-background-red"
        on:click={() => changeColor("red")}
      />
    </div>
  </div>
{/if}
